import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;
  }
</style>
</template>`;

styleElement.register('com-radio-group-style');